import Products_B_0 from './Products_B/Products_B_0'
import Products_B_1 from './Products_B/Products_B_1'
import Products_B_2 from './Products_B/Products_B_2'
import Products_B_3 from './Products_B/Products_B_3'
import Products_B_4 from './Products_B/Products_B_4'
import Products_B_5 from './Products_B/Products_B_5'
import Products_B_6 from './Products_B/Products_B_6'
import Products_B_7 from './Products_B/Products_B_7'
import Products_B_9 from './Products_B/Products_B_9'
import Products_B_10 from './Products_B/Products_B_10'
import Products_B_11 from './Products_B/Products_B_11'

const Products_B = [
  Products_B_0,
  Products_B_1,
  Products_B_2,
  Products_B_3,
  Products_B_4,
  Products_B_5,
  Products_B_6,
  Products_B_7,
  null,
  Products_B_9,
  Products_B_10,
  Products_B_11
]

export default Products_B



// WEBPACK FOOTER //
// ./src/components/Products_B.js